module.exports = __webpack_public_path__ + "img/goods-1.7b2cb42b.png";